import { LocationDto } from "src/dtos/location/locationDto";
import { WmsStockLotDto } from "src/dtos/wmsLot/wmsStockLotDto";

export interface WMS2061_R01Dto extends WmsStockLotDto {

	//lot제외 식별용 키
	groupKey: string;
	
	logicCenter: string;
	logicCenterNm: string;
	updateLotQty: number; // 실재고 입력값
	movedLotQty: number; // 이동재고량 표시값
	locationCd?: string;
	locationNm?: string;

}

export const defaultWMS2061_R01Dto: WMS2061_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	warehouseCd: '',
	warehouseNm: '',
	lotNo: '',
	purchaseLotNo: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	itemStatus: '',
	lotQty: 0,
	transportNo: '',
	itemNo: '',
	remark: '',
	
	groupKey: '',
	logicCenter: '',
	logicCenterNm: '',
	updateLotQty: 0,
	movedLotQty: 0,
	locationCd: '',
	locationNm: '',
	
	inserted: false,
	isModified: false,
}